import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import reduxCookiesMiddleware from "redux-cookies-middleware";
import loginReducer from "./features/login";
import { feedbackReducer } from "./feature/feedback";
import { instructor_reducer } from "./forms/index";
import addInstructor from "./forms/addInstructior";
import { TrainingCenter } from "./TrainingCenter/index";
import { veyon_reducer } from "./veyon";
import { Dashboard } from "./features/dashboard";
import { TrainingData } from "./features/Training";
import { TC } from "./features/trainingCenter";
import { InstructorReducer } from "./features/instructor";
import { studentReducer } from "./features/student";
import { tcAdminReducer } from "./features/trainingCenterAdmin";
import { ImageConfiguartor } from "./features/ImageConfigurator";
import { ImageDeatils } from "./features/ImageConfigReducer";
import { CreateSession } from "./features/CreateSessionReducer";
import { CreateSessionData } from "./features/CreatesessionDropdown";
import { CreateTrainings } from "./features/CreateSession";
import Redux_training_filter from "./filter/FilterRedux";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: [
    // "login",
    "trainingCenterDetails",
    "studentDetail",
    "instructorDetails",
    "tcAdminDetail",
  ],
};

const reducer = combineReducers({
  login: loginReducer,
  trainingCenterDetails: TC.trainingCenterIdSlice,
  instructorDetails: InstructorReducer.showInstructorDetails,
  studentDetail: studentReducer.showStudentDetails,
  tcAdminDetail: tcAdminReducer.showtcAdminDetails,
  feedback: feedbackReducer.feedbackReducer,
  admin_add_feedback: feedbackReducer.adminaddfeedback,
  someReducer: feedbackReducer.reducer,
  training_list: instructor_reducer.training_center_list,
  add_Instructor: addInstructor,
  location_list: instructor_reducer.location_list,
  primary_aws: instructor_reducer.primary_aws,
  add_training_center: instructor_reducer.add_training_center,
  studio_list: TrainingCenter.training_center_list,
  calender_data: veyon_reducer.calender_data,
  calender_selected_training: veyon_reducer.calender_selected_training,
  selected_training_student_data: veyon_reducer.selected_training_student_data,
  dashboard: Dashboard.Dashboard,
  training_list: TrainingData.Training_List,
  dashboard_graph: Dashboard.DashboardGraph,
  image_config: ImageConfiguartor.ImageConfig,
  ImageDetails: ImageDeatils,
  ImageStatus: ImageConfiguartor.ImageStatus,
  ImageByIdData: ImageConfiguartor.ImageByIdData,
  image_config_list: ImageConfiguartor.ImageConfiguratorList,
  region: TrainingCenter.region_list,
  test_image: ImageConfiguartor.TestImage,
  CreateSession: CreateSession,
  instructorData: CreateSessionData.InstructorList,
  studioList: CreateSessionData.StudioList,
  feedbackList: CreateSessionData.FeedbackList,
  feedbackData_by_id: feedbackReducer.getFeedbackById,
  feedback_update:feedbackReducer.updateFeedback,
  machineList: CreateSessionData.MachineList,
  instanceList: CreateSessionData.InstanceList,
  confirmImage: ImageConfiguartor.ConfirmImage,
  AllPageFilter: Redux_training_filter,
  autoAssign: CreateTrainings.AutoAssign,
  createTraining: CreateTrainings.CreateTraining,
  TrainingById: CreateTrainings.TrainingById,
  RescheduleTraining: CreateTrainings.RescheduleTraining,
});

const rootReducer = (state, action) => {
  if (action.type === "login/USER_LOGOUT") {
    storage.removeItem("persist:root");
    return reducer(undefined, action);
  }
  return reducer(state, action);
};

const paths = {
  "auth.token": { name: "my_app_token" },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: true,
    }),
});

export default store;
